import Vue from 'vue'

import NoAccess from '@/components/auth/noAccess.vue'
import AuthGroups from '@/mixins/auth/groups.js'

Vue.component('no-access', NoAccess)

Vue.mixin(AuthGroups)
